export default __webpack_public_path__ + "static/media/title-line.5ace5905.svg";